<ng-container *transloco="let t">
  @let clientCode = clientCode$ | async;
  <div class="bg-full-white">
    <header tuiHeader [scrollHeaderTitle]="scrollHeaderTitle$ | async">
      <h1 tuiTitle>
        {{ headerTitle$ | async }}
        @if (headerSubtitle$ | async; as subtitle) {
          <span tuiSubtitle>{{ subtitle }}</span>
        }
      </h1>
    </header>

    <pxc-filter-tabs />
  </div>

  <nav class="sticky z-20! flex flex-wrap items-center gap-2! py-2!" tuiNavigationNav>
    <pxc-filter-bar
      class="flex-1"
      data-testid="filter-bar"
      [searchPlaceholder]="t('Nom, prénom, nip ou date de naissance ...')" />
    <pxc-filter-buttons />
    <pxc-dropdown-button
      appearance="flat"
      class="shrink-0"
      data-testid="patient-order"
      icon="@tui.list-filter"
      [actions]="orderMenuActions"
      [selectedKey]="order$ | async" />
    @if (hasLicenseWriteAccess$ | async) {
      <button
        class="max-md:ml-auto"
        data-testid="add-patient"
        icon="@tui.user-plus"
        tuiButton
        type="button"
        (click)="createPatient(clientCode)">
        {{ t('Ajouter') }}
      </button>
    }
  </nav>

  @if ((isDataLoaded$ | async) === true) {
    <pxc-patient-list data-testid="patient-list" [order]="order$ | async" />
  } @else {
    <pxc-loader class="my-5" data-testid="loading">
      {{ t('Chargement des patients ...') }}
    </pxc-loader>
  }
</ng-container>
